import DateTimePickerWithMenu from './DateTimePickerWithMenu'
export const DateTimePicker = DateTimePickerWithMenu
export default DateTimePicker